<div [formGroup]="form">
  <kendo-datepicker
                    #dateElm
                    (focus)="onFocus(dateElm)"
                    [format]="'dd-MMM-yyyy'"
                    [id]="field.uniquename"
                    [formControlName]="field.uniquename"
                    placeholder="DD-MMM-YYYY"
                    [ngClass]="{'input-validation-error': isTouched && isInValid }"
                    style="max-width: 200px;"></kendo-datepicker>
</div>
